// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"90d394f8","732":"e454f41d","977":"f8bc02e4"}[chunkId] + ".chunk.js";
};